import { apiClient } from 'pobble-components/dist/api'

const apiConnectToWonde = (schoolId, wondeId) =>
  apiClient.post(
    `v3/schools/${schoolId}/wonde_operations/connect?include=school.wonde`,
    { school_wonde_id: wondeId }
  )

const apiDisconnectFromWonde = id =>
  apiClient.post(
    `v3/schools/${id}/wonde_operations/disconnect?include=school.wonde`
  )

const apiPullFromWonde = id =>
  apiClient.post(`v3/schools/${id}/wonde_operations/pull?include=school.wonde`)

const apiSearchWondeSchools = params =>
  apiClient.get('/v3/wonde_operations/search', { params })

const apiRequestGroupCallAccess = id =>
  apiClient.put(`/v3/schools/${id}/request_groupcall_sync`)

export {
  apiConnectToWonde,
  apiDisconnectFromWonde,
  apiPullFromWonde,
  apiSearchWondeSchools,
  apiRequestGroupCallAccess
}
